import { render, staticRenderFns } from "./PersonalDetailsViewer.vue?vue&type=template&id=116b825f&scoped=true"
import script from "./PersonalDetailsViewer.vue?vue&type=script&lang=js"
export * from "./PersonalDetailsViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116b825f",
  null
  
)

export default component.exports